export default __webpack_public_path__ + "static/media/Wire transfer.702a77f4.svg";